module.exports = __webpack_public_path__ + "img/20191204172339360截图20191204164015768.7dc7b57a.jpg";